<template lang="pug">
app-page(v-app-scroll="handleScroll" title="Управление категориями судьи" :loading="loading" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Категории которые рассматривает судья - ' + judgeFullName" back)
    app-toolbar-item.ml-2(label="Показать" :items="filterItems" key-name="title" min-width="120" @select="filterBy") {{ currentFilter }}
    app-toolbar-item.ml-2(label="Сортировать" :items="sorterItems" key-name="title" min-width="120" @select="sortBy") {{ currentSort }}
    v-btn.ml-2(@click.native="selectAll()")  {{ selectText() }}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="selectedFilter != 1" color="#757575" text-color="white" small label close @click:close="filterBy(filterItems[1], 1)") Фильтр:&nbsp;<b>{{ currentFilter }}</b>

  app-empty-list(v-if="list.length == 0") Список пуст
  app-group-animation
    app-group-item(v-for="c in list" :key="c.id" @click.native="toggleCategory(c)" cols="12")
      card-toggle(:title="uidCat(c)" :selected="isCategory(c)" data-aos="fade-top")
        app-card-title(v-html="titleCat(c)")
        app-card-caption(v-if="c.startDate" style="color: red;") Начало дествия: {{ c.startDate ? $_shortFormatRu(c.startDate) : '' }}
        app-card-caption(v-if="c.endDate" style="color: red;") Срок дествия до: {{ c.endDate ? $_shortFormatRu(c.endDate) : '' }}
        app-card-caption(v-if="c.outdated" style="color: red;") Устаревшая

  div(v-if="isCategoriesLoaded")
    button-back-page(@click.native="backJudge()") Готово ({{ currentJudge ? currentJudge.caseCategories.length : 0 }})

  app-dialog-loading(v-model="loadingSelectAll")
</template>

<script>
import { judgeService } from "@/_services";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { AppDialogLoading } from '@/components'

import CardToggle from '../components/CardToggle'
import ButtonBackPage from '../components/ButtonBackPage'
import { $_app_moment } from "@/common/AppMoment.js"

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment ],
  
  props: {
    judgeId: null
  },

  components: {
    [AppDialogLoading.name]: AppDialogLoading,
    CardToggle,
    ButtonBackPage
  },

  data () {
    return {
      loadingSelectAll: false,
      search: '',
      limit: 10,
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT', { judgeId: this.judgeId })

    this.$store.commit('setInCategory', true)
    this.$store.dispatch('category/INIT')
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['judgeFullName']),
    ...mapGetters('category', ['isCategoriesLoaded']),
    ...mapState('category', ['selectedSort', 'selectedFilter', 'categories']),


    sorterItems () {
      return ['по названию', 'по индексу'].map(el => ({ title: el }))
    },

    filterItems () {
      return ['все', 'активные', 'архивные', 'истек срок действия', 'рассматриваемые судьей', 'не рассматриваемые судьей'].map(el => ({ title: el }))
    },

    currentSort () {
      return this.sorterItems[this.selectedSort].title
    },

    currentFilter () {
      return this.filterItems[this.selectedFilter].title
    },

    loading () {
      return !this.isCategoriesLoaded
    },

    list () {
      return this.limit ? this.listCategories.slice(0, this.limit) : this.listCategories
    },

    listCategories () {
      let list = this.categories.list
      console.log(this.currentJudge.caseCategories.map(cat => cat.uuid))
      switch (this.selectedFilter) {
        case 1: {
          list = list.filter(item => item.outdated == null)
          list = list.filter(item =>  !item.endDate || ( item.endDate && moment(item.endDate).isAfter(moment()) ) )
          break
        }
        case 2: list = list.filter(item => item.outdated != null); break;
        case 3: list = list.filter(item =>  item.endDate && moment(item.endDate).isBefore(moment()) ); break;
        case 4: list = list.filter(item => this.currentJudge.caseCategories.map(cat => cat.id).includes(item.id) ); break;
        case 5: list = list.filter(item => !this.currentJudge.caseCategories.map(cat => cat.id).includes(item.id) ); break;
      }

      if (this.search) {
        list = list.filter(item => item.gasCategoryUid.toString().toLowerCase().includes(this.search) || item.title.toLowerCase().includes(this.search))
      }

      switch (this.selectedSort) {
        case 1: list.sort((a, b) => a.gasCategoryUid - b.gasCategoryUid || b.id - a.id); break;
        default: list.sort((a, b) => a.title.localeCompare(b.title) || b.id - a.id)
      }
      
      return list
    },
  },

  methods: {
    ...mapMutations('category', ['selectSort', 'selectFilter', 'setCategoriesStatus']),

    sortBy(item, index) {
      this.selectSort(index)
    },

    filterBy(item, index) {
      this.selectFilter(index)
    },

    titleCat (cat) {
      if (!this.search || this.search.length == 0 )  return cat.title

      return cat.title.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    uidCat (cat) {
      if (!this.search || this.search.length == 0 ) return cat.gasCategoryUid

      return cat.gasCategoryUid.toString().replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    isCategory (c) {
      return this.currentJudge.caseCategories.find(item => item.id == c.id)
    },

    selectText () {
      let text = "Добавить все"
      if (this.currentJudge.caseCategories && this.currentJudge.caseCategories.length == this.categories.length) text = "Отменить все"
      return text
    },

    selectAll () {
      this.loadingSelectAll = true
      if (this.currentJudge.caseCategories.length == this.listCategories.length) 
        this.currentJudge.caseCategories = []
      else {
        this.listCategories.map(c => {
          if (!this.isCategory(c)) this.currentJudge.caseCategories.push(c)
        })
      }
      
      this.currentJudge.signImage = null
      judgeService.updateJudge(this.currentJudge)
      this.loadingSelectAll = false
    },

    toggleCategory (c) {
      if (this.isCategory(c)) this.currentJudge.caseCategories = this.currentJudge.caseCategories.filter (cat => c.id != cat.id )
      else this.currentJudge.caseCategories.push(c)
    },

    backJudge () {
      this.currentJudge.signImage = null
      judgeService.updateJudge(this.currentJudge).then(() => this.$router.push({ path: `/admin/judges/${this.judgeId}` }))
    },

    handleScroll: function (evt, el) {
      let bottomOffset = el.scrollHeight - window.scrollY
      if (bottomOffset < 2 * window.innerHeight) {
        this.limit += 6
      }
      return false
    },

    resetList () {
      this.limit = 10
    }
  },

  watch: {
    cases () {
      this.resetList()
    }
  },

  beforeDestroy() {
    this.$store.commit('setInCategory', false) 
    this.$store.commit('setInJudgeReestr', false) 
  }
}
</script>


